import { FC } from 'react';
import useResponsiveRedux from '../Hooks/useResponsiveRedux';
import ListaUtenti from '../../pages/ListaUtenti';
import ListaUtentiMobile from '../../pages/Mobile/ListaUtentiMobile';

const ListaUtentiResponsive: FC = () => {
  const { isMobile } = useResponsiveRedux();
  return isMobile ? <ListaUtentiMobile /> : <ListaUtenti />;
};

export default ListaUtentiResponsive;
